<template>
  <div>
    <HeaderMain>
      {{ $t("page.scan_code_page.mainheader", {msgr: MESSENGERS[props.messenger].title}) }}
    </HeaderMain>

    <div class="block">
      <Transition name="fade" mode="out-in">
        <div class="buttonCase" :style="{ paddingTop: !qrSrc ? '40px' : '' }">
          <div class="qr_block">
            <Transition name="fade" mode="out-in">
              <img v-if="qrSrc" :src="qrSrc" class="" />
              <PreloaderBase v-else :color="msgrColor" />
            </Transition>
          </div>
          <Transition name="fade" mode="out-in">
            <button
              type="button"
              v-show="props.messenger === 'viber'"
              @click="openModal"
              class="notWorkCam"
            >
              <i class="fa fa-camera"></i>
              {{ $t(`page.generation.viber`) }}
            </button>
          </Transition>
        </div>
      </Transition>
      <div class="start">
        <p class="qr__timer-label">{{ $t("page.qr_timer.label") }}</p>

        <TimerBlock
          class="timer"
          :seconds="seconds"
          :isTimer="!store.state.activation.isPusher && !numberId"
          @timerTicks="() => getCustomStatus(number)"
          @timerFinish="timerFinish"
        ></TimerBlock>

        <p class="qr__timer-note">{{ $t("page.qr_timer.note") }}</p>

        <ol class="qr__steps">
          <li v-for="value in Object.keys($tm(textState))" :key="value">
            <span class="qr__num"></span>
            <span>
              {{
                $t(`${textState}.${value}`, {
                  msgr: MESSENGERS[props.messenger].title,
                })
              }}
            </span>
          </li>
        </ol>

        <div class="qr__notice">
          <i class="bi bi-exclamation-circle"></i>
          <p>
            <b>{{ $t("page.scan_code_page.important_label") }}</b>
            {{ $t("page.scan_code_page.important_text", {msgr: MESSENGERS[props.messenger].title}) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, watchEffect, onMounted, onUnmounted } from "vue";
import TimerBlock from "@/components/Recurring/TimerBlockRecurring";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import PreloaderBase from "@/components/Recurring/PreloaderBase";
import useCustomActivation from "./api/useCustomActivation";
import { useStore } from "vuex";
import MESSENGERS from "@/data/messengers.js";
import useActivationTelegram from "./api/useActivationTelegram";

const store = useStore();

const { getCustomStatus, customStatus } = useCustomActivation();
const { getStatusActivationTelegram, statusNumberActivation } =
  useActivationTelegram();

const qrSrc = ref(""); //require("/images/qrcode.svg")
const inputValue = ref("");
const previousMessenger = ref("");

const props = defineProps({
  number: {
    type: [String, Number],
    required: false,
  },
  numberId: {
    type: String,
    required: false,
  },
  messenger: {
    type: String,
    default: "viber",
  },
});

const emits = defineEmits(["nextStage"]);

const seconds = computed(() => {
  const currentMessenger = props.messenger || previousMessenger.value;
  switch (currentMessenger) {
    case "telegram":
      return 360;
    case "viber":
      return 200;
    case "whatsapp":
      return 120;
    default:
      console.error("no messenger");
      return 360;
  }
});

const textState = computed(() => {
  return props.numberId ? "page.scan_code_tg" : "page.scan_code";
});

const msgrColor = computed(() => MESSENGERS[props.messenger].color);

const qrLinkState = computed(() => store.state.activation.qrLink);

watch(
  () => customStatus.value,
  (newStatus) => {
    console.debug("after scancode", newStatus);
    emits("nextStage", newStatus);
  }
);

watch(
  () => props.messenger,
  (newVal) => {
    if (newVal !== "") {
      previousMessenger.value = newVal;
    }
  }
);

watch(qrLinkState, (newLink) => {
  qrURL(newLink);
});

watch(
  () => statusNumberActivation.value,
  (newStatus) => {
    emits("nextStage", newStatus);
  }
);

const timerFinish = () => {
  emits("nextStage", "timeOver");
};
const openModal = () => {
  store.commit("openDialog", {
    name: "ActivationLinkDialog",
    link: inputValue.value,
    messenger: MESSENGERS[props.messenger].title,
  });
};

const qrURL = async (url) => {
  !url && emits("nextStage", "oops");

  let link = await url.replace(/&amp;/g, "&");
  link = encodeURIComponent(link);

  const msg = props.numberId
    ? MESSENGERS.telegram.value
    : MESSENGERS.viber.value;

  qrSrc.value = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${link}`;
  if (!props.numberId) inputValue.value = url;
};

onMounted(() => {
  if (!props.number && !props.numberId) {
    emits("nextStage", "oops");
  } else {
    if (store.state.activation.qrLink) {
      qrURL(store.state.activation.qrLink);
        // getStatusActivationTelegram(props.numberId, store.state.activation.serverId);
    }
    if (!store.state.activation.isPusher && !props.numberId) {
      getCustomStatus(props.number, props.messenger);
    }
  }
});

onUnmounted(() => {
  store.commit("activation/CLEAR_QR_LINK");

  // the dialog lives in AppDialog and would outlive the expired link
  if (store.state.componentDialog === "ActivationLinkDialog" && store.state.isDialogOpen) {
    store.commit("closeDialog");
  }
});
</script>

<style lang="scss" scoped>
.buttonCase {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  min-height: 300px;
}

// the caption hangs under the code instead of pulling it above the text
.notWorkCam {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 0;
  white-space: nowrap;
}


.notWorkCam {
  margin-top: 15px;
  color: v-bind(msgrColor);
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.25s;
  padding: 13px 20px;
}

.page {
  .block {
    box-sizing: border-box;
    width: 100%;
    background: var(--block-color);
    display: flex;
    align-items: center;
    border-radius: 11px;
    padding: 50px 35px 65px 35px;
    gap: 55px;

    .start {
      flex: 1;
      min-width: 0;

      p {
        max-width: 600px;
        width: 100%;
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-family: "Gilroy";
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 30px;
        color: var(--text-second-color);
        margin: 10px 0 10px 0;
      }
    }
  }
}

// specific than a two-class selector, hence the .page .block prefix
.page .block .start {
  .qr__timer-label {
    display: block;
    max-width: none;
    margin: 0 0 10px;
    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    text-align: center;
    color: var(--text-color);
  }

  .qr__timer-note {
    display: block;
    max-width: none;
    margin: -18px 0 22px;
    font-family: "Gilroy", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: var(--text-third-color);
  }

  .qr__notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    margin-top: 20px;
    padding: 14px 18px;
    border: 1px solid #cdcaf3;
    border-radius: 7px;
    background: #ffffff;
    box-sizing: border-box;

    i {
      flex: 0 0 auto;
      margin-top: 4px;
      font-size: 18px;
      line-height: 1;
      color: v-bind(msgrColor);
    }

    p {
      display: block;
      max-width: none;
      margin: 0;

      font-family: "Gilroy", sans-serif;
      font-size: 16px;
      font-weight: 500;
      line-height: 25px;
      color: var(--text-third-color);
    }

    b {
      font-weight: 700;
      color: var(--text-color);
    }
  }
}

.timer :deep(.p1),
.timer :deep(.p2),
.timer :deep(.p4),
.timer :deep(.p5) {
  color: v-bind(msgrColor);
}

.qr__steps {
  list-style: none;
  counter-reset: qr-step;
  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: column;
  gap: 10px;

  li {
    counter-increment: qr-step;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin: 0;

    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 25px;
    color: var(--text-third-color);
  }
}

.qr__num {
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  margin-top: 1px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 7px;
  background: v-bind(msgrColor);
  color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-size: 13px;
  font-weight: 700;

  &::before {
    content: counter(qr-step);
  }
}

.qr_block {
  position: relative;
  max-width: 300px;
  height: 300px;
}

@media screen and (max-width: 900px) {
  .qr_block {
    height: 200px;
    width: 200px;
  }

  .page .block {
    gap: 15px;

    .start {
    }
  }

  .buttonCase {
    min-width: 200px;
  }
}

@media screen and (max-width: 750px) {
  .qr_block {
    max-width: 300px;
    width: 100%;
    height: 300px;
  }

  .page {
    .block {
      padding: 30px;
      gap: 30px;
      flex-direction: column;
      align-items: center;

      .start {
        .timer {
          margin: auto;
          margin-bottom: 30px;
        }

        p {
          font-size: 14px;
        }
      }
    }
  }

}

@media screen and (max-width: 550px) {
  .start {
    // width: 90%;
  }

  .qr_block {
    height: 200px;
    width: 200px;
  }
}

@media screen and (max-width: 400px) {
  .page {
    .block {
      padding: 10px;
    }
  }

}
</style>
